import React, { useEffect, useRef, useState } from 'react';
import config from '../../config';

const FancyYesValueBox = ({
  value,
  checkMaxOdds,
  validation,
  getLock,
  handleOnBackClick,
  isFancySuspend,
  isOddEven=false
}) => {
  const [highlightClass, setHighlightClass] = useState('');
  const prevValueRef = useRef({ yesValue: null, yesRate: null });
  const firstRender = useRef(true);

  const formatNumberNotFiex = (num) => {
    if (num >= 10000000) {
       return (num / 10000000).toFixed(2) + 'Cr'; // Crore
    } else if (num >= 100000) {
       return (num / 100000).toFixed(2) + 'L'; // Lakh
    } else if (num >= 1000) {
       return (num / 1000).toFixed(2) + 'K'; // Thousand
    } else {
       return num.toString(); // Less than 1000
    }
 };

  const formatNumber = (num) => {
    if (num >= 1000000000) {
       return (num / 1000000000).toFixed(2) + 'B'; // Billion
    } else if (num >= 1000000) {
       return (num / 1000000).toFixed(2) + 'M'; // Million
    } else if (num >= 1000) {
       return (num / 1000).toFixed(2) + 'K'; // Thousand
    } else {
       return num; // Less than 1000
    }
 };

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      prevValueRef.current = {
        yesValue: value.yesValue,
        yesRate: value.yesRate,
      };
      return;
    }

    const current = { yesValue: value.yesValue, yesRate: value.yesRate };
    const prev = prevValueRef.current;

    if (current.yesValue !== prev.yesValue || current.yesRate !== prev.yesRate) {
      if (current.yesValue > prev.yesValue || current.yesRate > prev.yesRate) {
        setHighlightClass('higilighted');
      } else if (current.yesValue < prev.yesValue || current.yesRate < prev.yesRate) {
        setHighlightClass('higilighted');
      }

      prevValueRef.current = current;

      setTimeout(() => {
        setHighlightClass('');
      }, 500);
    }
  }, [value.yesValue, value.yesRate]);

  const disabled = checkMaxOdds(value?.marketId, value.yesValue ?? 0);

  return (
    <span
      className={`blue ${disabled ? '' : 'disable'} ${highlightClass}`}
      onClick={() =>validation(value.yesValue) ? 
        handleOnBackClick(value, config.back, value?.marketId, value.yesValue, config.fancy, config.FANCY, value,isOddEven):''
      }
    >
      {isOddEven ? validation(value.yesValue) && !isFancySuspend(value) ? formatNumberNotFiex(value.yesRate) : getLock() :validation(value.yesValue) && !isFancySuspend(value) ? value.yesValue : getLock()}
      {isOddEven ? "" : <small>{validation(value.yesValue) && !isFancySuspend(value) ? formatNumberNotFiex(value.yesRate) : ''}</small>}
    </span>
  );
};

export default FancyYesValueBox;
